<template>
<div>
    <v-toolbar flat color="white" pt-4 mt-4>
        <v-btn round color="primary" @click="addUserGroupModal=true">
            Add User Group
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :search="search"
        :items="usergroups"
        item-key="id"
        align-center
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>

          <td class="text-xs-center">{{props.item.name}}</td>
           <td class="text-xs-center">{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addUserGroupModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD USER GROUP</h1></v-toolbar>
              <v-card-text>
                  <v-text-field label="User Group Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addUserGroupModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveUserGroup">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
</div>
  
</template>

<script>
import Api from "@/services/Api";
export default {
    props: ['usergroups'],
    data(){
        return {
            addUserGroupModal:false,
            item: {},
            headers: [
                {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }]
        }
    },
    methods: {
        deleteItem(item){
            Api()
            .put('/userGroup/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.$emit('userGroupChange'))
        },
        saveUserGroup(){
            Api()
            .post('/userGroup',{
                name: this.item.name,
                description: this.item.description,
                isActive: true,
                isDelete: false
            }).then(this.addUserGroupModal=false, this.item={}, this.$emit('userGroupChange'))
        }
    }

}
</script>

<style>

</style>